import { render, staticRenderFns } from "./UnifiedStudentUpload.vue?vue&type=template&id=15edee16&scoped=true"
import script from "./UnifiedStudentUpload.vue?vue&type=script&lang=js"
export * from "./UnifiedStudentUpload.vue?vue&type=script&lang=js"
import style0 from "./UnifiedStudentUpload.vue?vue&type=style&index=0&id=15edee16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15edee16",
  null
  
)

export default component.exports